module.exports = __webpack_public_path__ + "img/sello-eu-75-1-r.4d73d9de.png";